import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ChecklistItemLinesCompact from "./checklistItemLinesCompact";

function mapTemplateItems(items = []) {
  return items.map((item, index) => ({
    id: item.id ?? `preview-${index}`,
    title: item.title,
    description: "",
    guidance: item.guidance || item.description || "",
    input_fields: item.input_fields || [],
    input_values: {},
    response_actions: item.response_actions,
    documents_required: item.documents_required,
    row_order: item.row_order ?? index,
    isApproved: false,
    isDeviation: false,
    is_not_applicable: false,
    response_code: null,
  }));
}

export default function HseChecklistTemplatePreview({ template }) {
  const { t } = useTranslation();

  const previewChecklist = useMemo(
    () => ({
      id: null,
      checklist_type: {
        id: template?.id,
        default_response_actions: template?.default_response_actions || [],
      },
    }),
    [template?.id, template?.default_response_actions]
  );

  const previewItems = useMemo(
    () => mapTemplateItems(template?.items || []),
    [template]
  );

  if (!template?.id) return null;

  return (
    <div className="space-y-4">
      {template.description ? (
        <p className="text-sm text-gray-600 whitespace-pre-wrap">{template.description}</p>
      ) : null}
      <p className="text-xs font-medium uppercase tracking-wide text-emerald-800">
        {t("quality.checklist.type.hse.preview_label")}
      </p>
      {previewItems.length === 0 ? (
        <p className="text-sm text-gray-500">{t("quality.checklist.type.hse.preview_empty")}</p>
      ) : (
        <ChecklistItemLinesCompact
          checklist={previewChecklist}
          items={previewItems}
          editable={false}
          disabled
          preview
          drag={false}
          addRow={false}
          deleteRow={false}
          deviation={false}
          isLoading={false}
          type="checklist"
        />
      )}
    </div>
  );
}
